<template>
  <div>
    <v-row>
      <v-col cols="10">
        <breadcrumb :items="breadcrumbs"></breadcrumb>
      </v-col>
      <v-col cols="2">
        <v-btn text color="primary" class="mt-3"
          >Next Farm
          <v-icon right>
            mdi-chevron-right
          </v-icon></v-btn
        >
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row>
        <v-col cols="4" style="background-color: #ffffff;height:84vh;">
          <h3>Geofance means</h3>
          <div style="font-size: 14px;">
            Walk and measure or Use geofence tool to map out the location and
            delineate areas
          </div>
          <v-form lazy-validation autocomplete="off">
            <v-col cols="12">
              <label>Location Info:</label>
              <v-text-field placeholder="e.g 45.838 M" dense outlined></v-text-field>
            </v-col>
            <v-col cols="12">
              <label>Date of Interest:</label>
              <v-text-field placeholder="05/02/2022" dense outlined></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn
                outlined
                class="mr-2"
                right
                height="44"
                width="100%"
                depressed
                color="primary"
              >
                <img src="/img/walk.svg" /> Walk And Measurement
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn right height="44" width="100%" color="primary">
                <img src="/img/walk.svg" /> Use Geofencing Feature
              </v-btn>
            </v-col>
          </v-form>
        </v-col>
        <v-col
          cols="8" style="height:84vh;"
        >
          <v-text-field
            placeholder="Please Indicate your location"
            outlined
          ><v-icon slot="append"><img src="/img/location-pin.svg"/></v-icon></v-text-field>
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d10182931.849485777!2d20.43320098830723!3d47.75008417599982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2snp!4v1662010629071!5m2!1sen!2snp" width="100%" height="80%" style="border:0;" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import ProfileService from "../../_services/ProfileService";

export default {
  async mounted() {
    document.title = "Add Goal";
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 1000);
  },
  created() {
    this.getProfileData();
  },
  data() {
    return {
      loading: true,
      user: {
        name: "",
        role: "",
        userName: "",
      },
      breadcrumbs: [
        {
          text: this.$t("dashbaord"),
          disabled: false,
          to: "/",
        },
        {
          text: "Primary Geofence",
          disabled: true,
          to: "/primary-geofence",
        },
      ],
      showGoalSubjectDialog: false,
      showTargetValueDialog: false,
      showRegistrationSuccessDialog: false,
    };
  },
  methods: {
    getProfileData() {
      ProfileService.getProfileData()
        .then((res) => {
          if (res.success) {
            this.user.role = res.data.role;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}
.v-tab {
  text-transform: none !important;
}
</style>
